import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { getValue } from "@testing-library/user-event/dist/utils";

function FeePlanClassWise() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    getValues,
    reset,
  } = useForm();

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [centersData, setCentersData] = useState([]);
  const [centerClassesFeePlan, setCenterClassesFeePlan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // Ref to hold the previous value of isSaudi
  const isSaudi = watch("isSaudi");

  const previousIsSaudiRef = useRef(isSaudi);
  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setCentersData(response);

        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCenters();
  }, []);
  useEffect(() => {
    const fetchCenterClassesFeePlanByCenterId = async (id) => {
      setLoading(true);
      try {
        const response = await post(
          `FeePlan/GetCenterClassesFeePlanByCenterIdAsync?centerId=${id}&IsSaudi=${isSaudi}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { centerClassesFeePlan } = response;

        setCenterClassesFeePlan(centerClassesFeePlan);

        // reset();
      } catch (error) {
        console.error("Error fetching CenterClassesFeePlan:", error);
      } finally {
        setLoading(false);
      }
    };
    // Only call the API if isSaudi has changed
    if (previousIsSaudiRef.current !== isSaudi) {
      fetchCenterClassesFeePlanByCenterId(centerId);
      previousIsSaudiRef.current = isSaudi; // Update the ref
    }
  }, [centerId][isSaudi]);

  // const handleCenterDropdownChange = (event) => {
  //   const selectedCenterId = Number(event.target.value);
  //   setCenterId(selectedCenterId);
  //   setCenterClassesFeePlan([]);
  // };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    toast.error("An unexpected error occurred");
    return;

    const formData = centerClassesFeePlan.flatMap((centerItem, centerIndex) =>
      centerItem.centerFeePlanDetail.map((detail, detailIndex) => ({
        id: detail.id,
        amount:
          data.feePlanDetail[
            centerIndex * centerItem.centerFeePlanDetail.length + detailIndex
          ]?.amount || 0,
      }))
    );

    try {
      const response = await post(
        "FeePlan/UpdateCenterClassesFeeTypeAmountAsync",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const filteredClasses = centerClassesFeePlan.filter((centerItem) => {
    const lowerSearch = searchTerm.toLowerCase();
    const classMatches = centerItem.className?.toLowerCase().includes(lowerSearch);
    const detailMatches = centerItem.centerFeePlanDetail?.some(
      (detail) =>
        detail.feeTypeName?.toLowerCase().includes(lowerSearch) ||
        detail.amount?.toString().toLowerCase().includes(lowerSearch) ||
        detail.feeFrequency?.toLowerCase().includes(lowerSearch)
    );
    return classMatches || detailMatches;
  });

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Fee Plan Class Wise</h2>
      </div>

      <div className="row g-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form
                className="new-form-style"
                onSubmit={handleSubmit(saveData)}
              >
                <div className="row g-3">
                  <div className="col-12" style={{ width: "220px" }}>
                    <label className="form-label form-label-new">Center</label>
                    <Controller
                      name="centerId"
                      control={control}
                      rules={{ required: "This field is required." }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={centersData.map((center) => ({
                            value: center.id,
                            label: center.name,
                          }))}
                          isDisabled={savedCenterId !== "0"}
                          onChange={(selectedOption, actionMeta) => {
                            if (actionMeta.action === "clear") {
                              setValue(`centerId`, null);
                            } else {
                              setValue(
                                `centerId`,
                                selectedOption || { value: 0, label: "" }
                              );
                              setCenterId(selectedOption.value);
                            }
                            trigger(`centerId`);
                          }}
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                          // isClearable={!savedCenterId}
                        />
                      )}
                    />
                    {errors.centerId && (
                      <small className="text-danger">
                        {errors.centerId.message}
                      </small>
                    )}
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">
                      Is Saudi<span className="text-danger fs-9">*</span>
                    </label>
                    <input {...register("isSaudi")} type="checkbox" />
                    {errors.isSaudi && (
                      <small className="text-danger">
                        {errors.isSaudi.message}
                      </small>
                    )}
                  </div>
                </div>

                <div className="row g-3 mt-3">
                  <div className="col-md-4 ms-auto">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row g-3">
                  <div className="col-md-12">
                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      <table className="table table-bordered custom-table m-0">
                        <thead>
                          <tr>
                            <th>Class</th>
                            <th>Fee Type</th>
                            <th>Amount</th>
                            <th>One Time</th>
                            <th>Recurring</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!filteredClasses.length ? (
                            <tr className="text-center w-100">
                              <td colSpan="5">
                                There are no records to display
                              </td>
                            </tr>
                          ) : (
                            filteredClasses.map(
                              (centerItem, centerIndex) =>
                                centerItem.centerFeePlanDetail.map(
                                  (item, index) => (
                                    <tr key={item.id}>
                                      {index === 0 && (
                                        <th
                                          rowSpan={
                                            centerItem.centerFeePlanDetail
                                              .length
                                          }
                                          // style={{ transform: "rotate(-90deg)" }}
                                        >
                                          {centerItem.className}
                                        </th>
                                      )}
                                      <td>{item.feeTypeName}</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          {...register(
                                            `feePlanDetail[${
                                              centerIndex *
                                                centerItem.centerFeePlanDetail
                                                  .length +
                                              index
                                            }].amount`,
                                            {
                                              value: item.amount,
                                              maxLength: {
                                                value: 75,
                                                message:
                                                  "Maximum of 75 characters allowed.",
                                              },
                                            }
                                          )}
                                          defaultValue={item.amount}
                                          onInput={(e) => {
                                            if (e.target.value < 0) {
                                              e.target.value = 0;
                                            }
                                          }}
                                          onChange={handleChangeOfInputWithLengthCheck(
                                            `feePlanDetail[${index}].amount`
                                          )}
                                          disabled
                                        />
                                        {errors.feePlanDetail?.[
                                          centerIndex *
                                            centerItem.centerFeePlanDetail
                                              .length +
                                            index
                                        ]?.amount && (
                                          <div className="text-danger">
                                            {
                                              errors.feePlanDetail[
                                                centerIndex *
                                                  centerItem.centerFeePlanDetail
                                                    .length +
                                                  index
                                              ]?.amount?.message
                                            }
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        <div className="d-flex justify-content-center">
                                          <span
                                            className={`text-primary fa ${
                                              item.feeFrequency === "One Time"
                                                ? "fa-check"
                                                : ""
                                            }`}
                                          ></span>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex justify-content-center">
                                          <span
                                            className={`text-primary fa ${
                                              item.feeFrequency === "Recurring"
                                                ? "fa-check"
                                                : ""
                                            }`}
                                          ></span>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )
                            )
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary btn-sm"
                      type="submit"
                      // disabled={isSubmitting}
                      disabled
                    >
                      {isSubmitting ? "Save" : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeePlanClassWise;
